module.exports = __webpack_public_path__ + "static/media/alifeinaday.21e70ac9.png";